import { z } from 'zod';
import { servicesProviderPricingFlatFeeSchema, servicesProviderPricingLinearSchema, servicesProviderPricingSteppedSchema, servicesProviderPricingStateBasedFeeSchema, servicesProviderPricingStarEvDeliveryEstimateSchema, servicesProviderPricingFlatFeeDtoSchema, servicesProviderPricingLinearDtoSchema, servicesProviderPricingSteppedDtoSchema, servicesProviderPricingStateBasedFeeDtoSchema, servicesProviderPricingStarEvDeliveryEstimateDtoSchema } from '../ServicesProviderPricing.js';
import { serviceConfigSchema } from './SharedServiceConfig.js';

// ============================================================================
// Pricing Schemas
// ============================================================================
const deliveryServicePricingSchema = z.discriminatedUnion('model', [
    servicesProviderPricingFlatFeeSchema,
    servicesProviderPricingLinearSchema,
    servicesProviderPricingSteppedSchema,
    servicesProviderPricingStateBasedFeeSchema,
    servicesProviderPricingStarEvDeliveryEstimateSchema,
]);
const deliveryServicePricingDtoSchema = z.discriminatedUnion('model', [
    servicesProviderPricingFlatFeeDtoSchema,
    servicesProviderPricingLinearDtoSchema,
    servicesProviderPricingSteppedDtoSchema,
    servicesProviderPricingStateBasedFeeDtoSchema,
    servicesProviderPricingStarEvDeliveryEstimateDtoSchema,
]);
// ============================================================================
// Core Schema
// ============================================================================
const deliveryServiceConfigSchema = serviceConfigSchema.extend({
    deliveryEstimateRange: z
        .object({
        min: z.number().optional(),
        max: z.number().optional(),
    })
        .optional(),
    pricing: z.array(deliveryServicePricingSchema),
    averageDeliveryTime: z.number(),
    requiresAssemblyAfterDelivery: z.boolean(),
    stateData: z
        .record(z.object({
        deliveryEstimate: z.number().optional(),
    }))
        .optional(),
    deliveryEstimate: z.number().optional(),
});
const deliveryServiceConfigDtoSchema = serviceConfigSchema.extend({
    deliveryEstimateRange: z
        .object({
        min: z.coerce.number().optional(),
        max: z.coerce.number().optional(),
    })
        .optional(),
    pricing: z.array(deliveryServicePricingDtoSchema),
    averageDeliveryTime: z.coerce.number(),
    requiresAssemblyAfterDelivery: z.boolean(),
});

export { deliveryServiceConfigDtoSchema, deliveryServiceConfigSchema, deliveryServicePricingDtoSchema, deliveryServicePricingSchema };
//# sourceMappingURL=DeliveryServiceConfig.js.map
